import React, { useState } from 'react';

import SortIcon from "@mui/icons-material/Sort";
import Tablestock from "../../components/TableInventory/TableStocks";
import { Box, Button,TextField, IconButton, Tooltip, useMediaQuery } from '@mui/material';
import { useNavigate } from 'react-router-dom';


function InventorySearch() {
  let navigate = useNavigate(); 
  const isMobile = useMediaQuery('(max-width:760px)');

  const [searchQuery, setSearchQuery] = useState("");
  const [sortField, setSortField] = useState("productName")
  const routeChange = (productId) => {
    let path = `/product/productdetail/${productId}`;  
    navigate(path);
    
  }

  const sortingFields = ["productName", "categoryName", "subcategoryName"];
  const sortingFieldLabels = {
    productName: "Name",
    categoryName: "Category",
    subcategoryName: "Subcategory",
  };

  const handleSortChange = () => {
    const currentIndex = sortingFields.indexOf(sortField);
    const nextIndex = (currentIndex + 1) % sortingFields.length;
    setSortField(sortingFields[nextIndex]);
  };
  
  const buttonStyle = {
    backgroundColor: "#007bff",
    color: "white",
    border: "none",
    padding: "10px 20px",
    fontSize: "16px",
    borderRadius: "5px",
    cursor: "pointer",
    fontFamily: "Roboto",
    transition: "background-color 0.3s ease",
};


  const buttonHoverStyle = (event, isHovering) => {
    event.target.style.backgroundColor = isHovering ? "#0056b3" : "#007bff";
  };

  return (
    <div >
     <h1 style={{ fontFamily: "Roboto"}}>Inventory</h1>
    
      <button
        onClick={() => navigate("/inventory/addstock")}
        style={buttonStyle}
        onMouseEnter={(e) => buttonHoverStyle(e, true)}
        onMouseLeave={(e) => buttonHoverStyle(e, false)}
      >
        Create New Batch
      </button>
      <Box className="search-container">
        <TextField
          label="Search"
          variant="outlined"
          margin="normal"
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
        />

        {/* <Tooltip title={`Sort by ${sortingFieldLabels[sortField]}`}>
          <IconButton onClick={handleSortChange}>
            <SortIcon
              style={{
                fontSize: "30px",
                color: "black",
                marginTop: "10px",
                fontFamily: "Roboto",
                marginLeft: "7px",
              }}
            />
          </IconButton>
        </Tooltip>

        <span
          style={{
            fontSize: "14px",
            fontWeight: "bold",
            fontFamily: "Roboto",
            marginLeft: "0.8px",
            marginTop: "0.5cm",
          }}
        >
          {sortingFieldLabels[sortField]}
        </span> */}
      </Box>

      {/* Pass Search Query & Sorting Field as Props to Table */}
      <Tablestock searchQuery={searchQuery} />
      
      
      
      </div>
   
  );
};

export default InventorySearch;


 